const modifiedFields = ['notificationsModel'];
const modifiedFieldCustom = {
  notificationsModel: ['recipientKey', 'recipientName', 'notificationMethods', 'recipientType']
};
const sortByFields = {
  notificationsModel: ['recipientName'],
  orderBy: ['asc']
};
export default { modifiedFields, modifiedFieldCustom, sortByFields };
